import { clientLabel } from '@/lib/client-label';
import type { FinanceBook, FinanceSession } from './book';

export function financeBookHeading(book: FinanceBook, operatorName: string, clientName: string) {
  switch (book.kind) {
    case 'operator':
      return { title: operatorName, subtitle: 'All Clients' };
    case 'client':
      return { title: clientName, subtitle: operatorName };
    case 'mine':
      return { title: 'My clients', subtitle: null };
    default: {
      const unreachable: never = book;
      return unreachable;
    }
  }
}

export function financeSessionHeading(session: Pick<FinanceSession, 'book' | 'clients' | 'operatorName'>) {
  const bookClientId = session.book.kind === 'client' ? session.book.clientId : null;
  const client = bookClientId ? session.clients.find((entry) => entry.id === bookClientId) : undefined;
  // Distinguish clients that share a display name: the picker rows carry the
  // internal legal name as a subtitle, so the closed heading must too.
  const clientName = client ? clientLabel(client) : (bookClientId ?? '');
  return financeBookHeading(session.book, session.operatorName, clientName);
}
